import React from 'react';

import { Box } from '@mui/material';

import { QueryMode } from 'src/api';
import { DashboardReportsPeo } from 'src/components/dashboard';
import { DashboardFilter } from 'src/components/dashboard/components';
import { useEmployersAutocomplete } from 'src/hooks/employer';
import { useCurrentUserPeo } from 'src/hooks/peo';
import { useCurrentUserPeoPayrollProvider } from 'src/hooks/peoPayrollProvider';
import { useCurrentUserPermissions } from 'src/hooks/user';
import { FilterProvider } from 'src/providers/FilterProvider';

export const DashboardPeoPage: React.FC = () => {
  const { isPeoPayrollProviderUser, hasPeoRoles } = useCurrentUserPermissions();

  const { peo, loading: isPeoLoading } = useCurrentUserPeo();
  const { peoPayrollProvider, loading: isPeoPpLoading } = useCurrentUserPeoPayrollProvider();

  const employerAutocompleteOptions = useEmployersAutocomplete({
    queryFilter: searchText => ({
      filter: { displayName: { contains: searchText, mode: QueryMode.Insensitive } },
    }),
    queryOptions: {
      variables: {
        filter: {
          ...(hasPeoRoles ? { peoId: { equals: peo?.id } } : {}),
          ...(isPeoPayrollProviderUser
            ? {
                OR: [
                  { peoPayrollProviderId: { equals: peoPayrollProvider?.id } },
                  { peo: { peoPayrollProviderId: { equals: peoPayrollProvider?.id } } },
                ],
              }
            : {}),
        },
      },
      skip: !peo?.id && !peoPayrollProvider?.id,
    },
  });

  const createdAtCompany = React.useMemo(() => {
    return peo?.createdAt || peoPayrollProvider?.createdAt || '';
  }, [peo?.createdAt, peoPayrollProvider?.createdAt]);

  const isLoading = isPeoLoading || isPeoPpLoading;

  return (
    <FilterProvider>
      <Box paddingX={2} paddingTop={2}>
        <DashboardFilter autocompleteFieldProps={employerAutocompleteOptions} />
      </Box>

      <DashboardReportsPeo createdAtCompany={createdAtCompany} loading={isLoading} />
    </FilterProvider>
  );
};
